<footer class="patient-footer">
  <div class="footer-content">
    <span class="footer-left">
      &copy; {{this.footerPrefix}} polya⁺
    </span>

    <nav class="footer-right">
      <a [routerLink]="['/license']">{{ 'FOOTER.DISCLAIMER_LICENSE' | translate }}</a>
      <span class="separator" aria-hidden="true">|</span>
      <a href="https://polya.de/datenschutz" target="_blank" rel="noopener">{{ 'FOOTER.DATAPROTECTION' | translate }}</a>
      <span class="separator" aria-hidden="true">|</span>
      <a href="https://polya.de/accessibility" target="_blank" rel="noopener">{{ 'FOOTER.ACCESSIBILITY' | translate }}</a>
      <span class="separator" aria-hidden="true">|</span>
      <a href="https://polya.de/impressum" target="_blank" rel="noopener">{{ 'FOOTER.LEGALDISCLOSURE.IMPRINT' | translate }}</a>
    </nav>
  </div>
</footer>
